<nz-card>
    <div>
        <form nz-form [formGroup]="validateForm">
            <nz-form-item class="mb-sm">
                <nz-form-label [nzSpan]="6" nzFor="campany">{{ 'SRSettingKey' | translate }}</nz-form-label>
                <nz-form-control [nzSpan]="5">
                    <nz-select formControlName="settingKey" nzAllowClear>
                        <nz-option *ngFor="let item of settingKeyList" [nzValue]="item" [nzLabel]="item"></nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>

            <nz-form-item class="mb-sm">
                <nz-form-label [nzSpan]="6" nzFor="vendorcode">{{ 'SRSettingValue' | translate }}</nz-form-label>
                <nz-form-control [nzSpan]="5">
                    <input type="text" nz-input formControlName="settingValue" nz-input />
                </nz-form-control>
            </nz-form-item>

            <nz-form-item class="mb-sm">
                <nz-form-label [nzSpan]="6" nzFor="stat">{{ 'Status' | translate }}</nz-form-label>
                <nz-form-control [nzSpan]="5">
                    <nz-select formControlName="isEnabled" nzAllowClear>
                        <nz-option *ngFor="let item of statList" [nzValue]="item" [nzLabel]="item"></nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>

        </form>

        <nz-form-item>
            <nz-form-control [nzSm]="{ span: 1, offset: 7 }">
                <button nz-button nzType="primary" class="default-button" (click)="onSearch()">{{ 'Search' |
                    translate }}</button>
            </nz-form-control>
        </nz-form-item>
    </div>
</nz-card>

<nz-card nzTitle="{{'Results' | translate}}({{total}})">
    <nz-table #colSpanTable class="fixed-col-table-scroll" [nzData]="listOfData" style="margin-bottom: 10px" nzSize="middle" nzShowSizeChanger
        [nzFrontPagination]="false" [nzShowPagination]='false' [nzPageSize]='pageSize' [nzPageIndex]='pageIndex'
        (nzCurrentPageDataChange)="onCurrentPageDataChange($event)" [nzScroll]="{ y: '800px',x:'200px' }">
        <thead>
            <tr>
                <th scope="col" style="text-align:center;" [nzSortFn]="true" nzWidth="5px"
                    (nzSortOrderChange)="sortChange({ key: 'site', value: $event })">{{ "SRSettingKey" | translate }}
                </th>
                <th scope="col" style="text-align:center;" [nzSortFn]="true" nzWidth="5px"
                    (nzSortOrderChange)="sortChange({ key: 'remark', value: $event })">{{ "Remark" | translate}}
                </th>
                <th scope="col" style="text-align:center;" [nzSortFn]="true" nzWidth="5px"
                    (nzSortOrderChange)="sortChange({ key: 'strategy', value: $event })">{{ "SRSettingStrategy" |
                    translate}}
                </th>
                <th scope="col" style="text-align:center;" [nzSortFn]="true" nzWidth="5px"
                    (nzSortOrderChange)="sortChange({ key: 'creatorId', value: $event })">{{ "CreatorId" | translate}}
                </th>
                <th scope="col" style="text-align:center;" [nzSortFn]="true" nzWidth="5px"
                    (nzSortOrderChange)="sortChange({ key: 'creationTime', value: $event })">{{ "CreationTime" |
                    translate}}
                </th>
                <th scope="col" style="text-align:center;" [nzSortFn]="true" nzWidth="5px"
                    (nzSortOrderChange)="sortChange({ key: 'lastModifierId', value: $event })">{{ "LastModifierId" |
                    translate}}
                </th>
                <th scope="col" style="text-align:center;" [nzSortFn]="true" nzWidth="5px"
                    (nzSortOrderChange)="sortChange({ key: 'lastModificationTime', value: $event })">{{
                    "LastModificationTime" | translate}}
                </th>
                <th scope="col" style="text-align:center;" [nzRight]="true" nzWidth="5px">{{ "Edit" | translate}}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let data of colSpanTable.data;let i=index">
                <td>{{data.key}}</td>
                <td>{{data.remark}}</td>
                <td>{{ getStrategyName(data.strategy) }}</td>
                <td>{{data.creatorId}}</td>
                <td>{{data.creationTime | date:'yyyy-MM-dd'}}</td>
                <td>{{data.lastModifierId}}</td>
                <td>{{data.lastModificationTime | date:'yyyy-MM-dd'}}</td>
                <td style="text-align:center;" class="fixed-column" [nzRight]="true">
                    <span nz-icon nzType="edit" nzTheme="twotone" style="font-size: 20px; cursor: pointer;" nz-tooltip
                        (click)="onEdit(data.key)"></span>
                </td>
            </tr>
        </tbody>
    </nz-table>
</nz-card>

<nz-modal [nzTitle]="'Edit'" [nzVisible]="isEditModalVisible" [nzContent]="modalContent" (nzOnOk)="onSure($event)"
    (nzOnCancel)="onCancel()" [nzMaskClosable]="false">

    <ng-template #modalContent>
        <form nz-form [formGroup]="editValidateForm">
            <nz-form-item class="mb-sm">
                <nz-form-label [nzSpan]="6" nzRequired>{{ "SRSettingKey" | translate }}</nz-form-label>
                <nz-form-control [nzSpan]="8">
                    <input readonly nz-input formControlName="settingKey">
                </nz-form-control>
            </nz-form-item>

            <nz-form-item class="mb-sm">
                <nz-form-label [nzSpan]="6" nzRequired>{{ "Lang" | translate }}</nz-form-label>
                <nz-form-control [nzSpan]="8">
                    <nz-select formControlName="lang" nzAllowClear>
                        <nz-option *ngFor="let item of langList" [nzValue]="item.value"
                            [nzLabel]="item.label"></nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
        </form>

        <button *ngIf="langIsSelected" nz-button (click)="openAddModal()" [nzType]="'default'">
            <i nz-icon nzType="plus"></i>
            <span>{{ 'Add' | translate }}</span>
        </button>
        <nz-table *ngIf="langIsSelected" #rowSelectionTable nzShowSizeChanger [nzData]="detailData" nzSize="middle"
            [nzFrontPagination]="false" [nzShowPagination]='false' [nzPageSize]='pageSize' [nzPageIndex]='pageIndex'
            (nzCurrentPageDataChange)="onCurrentPageDataChange($event)">
            <thead>
                <tr>
                    <th nzWidth="10%" scope="col">{{"SiteNo" | translate}}</th>
                    <th nzWidth="10%" scope="col">{{"CompanyCode" | translate}}</th>
                    <th scope="col">{{"SettingValue" | translate}}</th>
                    <th nzWidth="5%" scope="col">{{"SettingItem" | translate}}</th>
                    <th nzWidth="15%">Action</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let data of rowSelectionTable.data">
                    <!-- <td>{{ data.siteNo}}</td>
                    <td>{{ data.companyCode}}</td>
                    <td>{{ data.value }}</td>
                    <td>{{ data.item}}</td>
                    <td><a (click)="startEdit(data.item)">Edit</a></td> -->
                    <ng-container *ngIf="!editCache[data.item].edit; else editTemplate">
                        <td>{{ data.siteNo }}</td>
                        <td>{{ data.companyCode }}</td>
                        <td>{{ data.value }}</td>
                        <td>{{ data.item}}</td>
                        <td><a (click)="startEdit(data.item)">Edit</a></td>
                    </ng-container>
                    <ng-template #editTemplate>
                        <td><input disabled type="text" nz-input [(ngModel)]="editCache[data.item].data.siteNo" /></td>
                        <td><input disabled type="text" nz-input [(ngModel)]="editCache[data.item].data.companyCode" />
                        </td>
                        <td><input type="text" nz-input [(ngModel)]="editCache[data.item].data.value" /></td>
                        <td><input disabled type="text" nz-input [(ngModel)]="editCache[data.item].data.item" /></td>
                        <td>
                            <a (click)="saveEdit(data.item)" class="save">Save</a>
                            <a nz-popconfirm nzPopconfirmTitle="Sure to cancel?" (nzOnConfirm)="cancelEdit(data.item)"
                                class="action-link">Cancel</a>
                        </td>
                    </ng-template>
                </tr>
            </tbody>
        </nz-table>

    </ng-template>
</nz-modal>

<nz-modal [nzTitle]="'Add'" [nzVisible]="isAddModalVisible" [nzContent]="addModalContent" (nzOnOk)="onAddSure($event)"
    (nzOnCancel)="onAddCancel()" [nzMaskClosable]="false"> 
    <ng-template #addModalContent>
        <form nz-form [formGroup]="addValidateForm">
            <nz-form-item class="mb-sm">
                <nz-form-label [nzSpan]="6" nzRequired>{{ "SRSettingKey" | translate }}</nz-form-label>
                <nz-form-control [nzSpan]="8">
                    <input disabled nz-input formControlName="settingKey">
                </nz-form-control>
            </nz-form-item>

            <nz-form-item class="mb-sm">
                <nz-form-label [nzSpan]="6" nzRequired>{{ "Lang" | translate }}</nz-form-label>
                <nz-form-control [nzSpan]="8">
                    <input disabled nz-input formControlName="lang">
                </nz-form-control>
            </nz-form-item>

            <nz-form-item class="mb-sm">
                <nz-form-label [nzSpan]="6">{{ "SiteNo" | translate }}</nz-form-label>
                <nz-form-control [nzSpan]="8">
                    <input nz-input formControlName="siteNo">
                </nz-form-control>
            </nz-form-item>

            <nz-form-item class="mb-sm">
                <nz-form-label [nzSpan]="6">{{ "CompanyCode" | translate }}</nz-form-label>
                <nz-form-control [nzSpan]="8">
                    <input nz-input formControlName="companyCode">
                </nz-form-control>
            </nz-form-item>

            <nz-form-item class="mb-sm">
                <nz-form-label [nzSpan]="6">{{ "SRSettingValue" | translate }}</nz-form-label>
                <nz-form-control [nzSpan]="8">
                    <input nz-input formControlName="settingValue">
                </nz-form-control>
            </nz-form-item>
        </form>
    </ng-template>
</nz-modal>